import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-no-vendor-page',
  imports: [RouterLink],
  template: `
    <div class="mx-auto w-80 pt-40 md:w-[600px]">
      <div class="text-center">
        <div class="-mt-8 text-6xl font-bold uppercase">OUPS !</div>
        <div class="mt-4 text-lg font-bold uppercase">
          Votre compte n'est pas associé à une organisation.
        </div>
      </div>

      <p class="mt-4 text-base">
        Pour accéder à la plateforme, choisissez l'une des options suivantes :
      </p>
      <ol class="mt-4">
        <li
          >Vous souhaitez
          <span class="font-bold">rejoindre une organisation</span> existante ?
          Contactez votre administrateur pour obtenir une invitation.</li
        >
        <li
          >Vous souhaitez
          <span class="font-bold">créer une nouvelle organisation</span> ?
          <a
            routerLink="/auth/devenir-un-hote"
            class="text-secondary-500 underline"
            >Créer un compte hôte</a
          ></li
        >
      </ol>
    </div>
  `,
  styles: ``,
})
export class NoVendorPageComponent {
  constructor() {}
}
